module.exports = __webpack_public_path__ + "media/theme/icon__respons--retina-ea2554fd.png";